import { render } from "./donationHome.vue?vue&type=template&id=2687f612&scoped=true"
import script from "./donationHome.vue?vue&type=script&lang=js"
export * from "./donationHome.vue?vue&type=script&lang=js"

import "./donationHome.vue?vue&type=style&index=0&id=2687f612&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2687f612"]])

export default __exports__